var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center"}},_vm._l((_vm.items),function(item){return _c('v-col',{key:item.id,attrs:{"cols":"12","sm":"6","md":_vm.isCollapse ? 6 : 4,"xl":"3"}},[_vm._t("item",null,{"item":item})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }